import React from "react";
import { DataLayerEvent } from "../services/lsq";
// import GMap from "../components/GMap";
import "../App.css"

function ThankYou() {
  DataLayerEvent("thankyou_page")
  return (
    <>
    <header>
        <div className="container container-ty">
          <nav className="d-flex justify-content-between  align-items-center">
            <div className="d-flex align-items-center">
              <a href="">
                <img
                  src="../dist/img/icici_logo.webp"
                  alt="ICICI Bank Logo"
                  width="252"
                  height="50"
                  className="img-fluid"
                />
              </a>
            </div>
          </nav>
        </div>
      </header> 
  <div className="thankyou-map">
  {/* <div className="col-lg-6">   */}
    <article className="thankyou_sec">
		<div className="tick">
			<img src="../dist/img/tick.webp" alt="tick" width="100" height="100" className="img-fluid" />
		</div>
		<div className="thankyou_txt">
			<p>Thank You for your interest in<br className="br1"/> ICICI Bank.<br className="br2" />
			 Our Relationship Manager<br className="br3" /> will get in touch with you shortly.  </p>       
		</div>
    
	</article>

  {/* <div className="gmap-div"><GMap /></div> */}
  </div>
  {/* </div> */}
    </>
  );
}

export default ThankYou;
